import React from "react";

import "./hero.style.css";

const Hero = () => {
  return (
    <div className="hero">
      <h1 className="subtitle">Welcome</h1>
    </div>
  );
};

export default Hero;
